/*
 * Copyright (C) 2015 Spanning Cloud Apps LLC.  All rights reserved.
 */
import './bulkRestoreDetails.tpl.html';

/**
 * Module for the mobile bulkRestoreDetails.
 */
angular
  .module('mobile.batch.bulkRestore.details', [])
  /**
   * Controller for the MobileBulkRestoreDetails template.
   */
  .controller('MobileBulkRestoreDetailsCtrl', [
    '$scope',
    '$filter',
    'BATCH_RESULTS',
    'BulkRestoreService',
    'pagingUtils',
    function ($scope, $filter, BATCH_RESULTS, BulkRestoreService, pagingUtils) {
      $scope.restoredRecords = [];
      $scope.initialLoad = true;
      $scope.showLoadingIndicator = false;

      $scope.pagingParam = pagingUtils.pagingInfo.bulkRestoreDetails;

      // Paging stuff
      $scope.pagingParam.currentPage = 0;

      /**
       * Utility to retrieve the records with the current parameters and update
       * the data on the page.
       */
      $scope.updateRecords = function () {
        var query = '';
        $scope.showLoadingIndicator = true;
        $scope.pagingParam.currentPage = $scope.pagingParam.currentPage + 1;
        $scope.pagingParam = pagingUtils.pagingInfo.bulkRestoreDetails;
        if ($scope.$parent) {
          $scope.$parent.showDetailsMask = true;
          query = $scope.$parent.bulkRestoreQuery;
        }
        var params = {
          batchId: $scope.batchUtils.currentBatch.batchId,
          page: $scope.pagingParam.currentPage - 1,
          pageSize: $scope.pagingParam.itemsPerPage,
          filter: query,
          sort: $scope.pagingParam.sortBy,
          ascending: $scope.pagingParam.ascending
        };

        BulkRestoreService.getBatchDetails(params).then(function (results) {
          $scope.pagingParam.totalPages = Math.ceil(results.numberOfRecords / $scope.pagingParam.itemsPerPage);
          $scope.pagingParam.totalItems = results.numberOfRecords;
          pagingUtils.pagingInfo.bulkRestoreDetails = $scope.pagingParam;
          var newRecords = $scope.restoredRecords.concat(results.records);
          $scope.restoredRecords = newRecords;
          $scope.initialLoad = false;
          if ($scope.pagingParam.totalPages > $scope.pagingParam.currentPage) {
            $scope.showLoadingIndicator = false;
          }
          if ($scope.$parent) {
            $scope.$parent.showDetailsMask = false;
          }
        });
      };

      $scope.updateRecords();

      if ($scope.batchUtils.currentBatch && $scope.batchUtils.currentBatch.status !== BATCH_RESULTS.FAILURE) {
        $scope.noRestore = false;
      } else {
        $scope.noRecordsRestoredMessage = $filter('i18n')('NO_RECORDS_RESTORED');
        $scope.noRestore = true;
      }
    }
  ]);
